import React from 'react'
import { Headline, Body } from 'uiComponents/typography'
import { NestedContainerWrapper } from 'uiComponents/table/nestedContainer'
import { TimeSlotGroup } from './timeSlotsService'
import { TimeSlotsListRow } from './listRow'
import { useTranslation } from 'translations'
import './listBody.scss'

interface TimeSlotProductList {
    name: string
    id: string
}

export interface ListProps {
    accountSlug: string
    timeSlots: TimeSlotGroup[]
    flattenedCategories: TimeSlotProductList[]
    expandedElement: string
    productsView: boolean
    setExpandedTimeSlot: (id: string) => void
    onPriorityUpdateConfirm: (priority: string, id: string) => void
    hasPermission: (permission: string, accountSlug: string) => boolean
    hasFeature: (feature: string, slug: string) => boolean
    redesign?: boolean
    // With a search selection the second column names what each group applies to, whatever the view.
    describeTarget?: boolean
}

export function TimeSlotsList(props: ListProps) {
    const { t } = useTranslation()
    return (
        <>
            {props.timeSlots.map((ts) => {
                const isExpanded = props.expandedElement === ts.id
                return (
                    <div key={ts.id}>
                        <TimeSlotsListRow
                            accountSlug={props.accountSlug}
                            timeslot={ts}
                            redesign={props.redesign}
                            describeTarget={props.describeTarget}
                            productsView={props.productsView}
                            onPriorityUpdateConfirm={props.onPriorityUpdateConfirm}
                            hasPermission={props.hasPermission}
                            productsViewFeatureOn={props.hasFeature('TimeSlotsForProduct', props.accountSlug)}
                            toggleExpanded={() => props.setExpandedTimeSlot(ts.id)}
                            isExpanded={isExpanded}
                        />
                        {!!isExpanded && (
                            <NestedContainerWrapper grade={0} className="expanded">
                                <div className="timeslots-expanded-area">
                                    <Headline size={6} className="timeslots-expanded-title">
                                        {t('timeSlots.list.expandedCategoriesTitle')}
                                    </Headline>
                                    {ts.productsLists.map((pl) => {
                                        const plData = props.flattenedCategories.find((c) => c.id === pl.id)
                                        return plData ? (
                                            <Body
                                                size={1}
                                                weight="light"
                                                className="timeslots-expanded-item"
                                                key={plData.id}
                                            >
                                                {plData.name}
                                            </Body>
                                        ) : null
                                    })}
                                </div>
                            </NestedContainerWrapper>
                        )}
                    </div>
                )
            })}
        </>
    )
}
